import TeacherQuestionView from './TeacherQuestionView';
import { connect } from 'react-redux';
import {
  getExamLoadingStatus,
  getSolution,
  getQuestion,
} from '../../data/selectors';
import { loadExam, loadExamSolution } from '../../data/actions';

// TeacherQuestionView displays the question in a non-interactable way with the
// correct answer selected (if applicable). It is used for the teacher review
// experience, to show the teacher what the question they are reviewing looks
// like.

const mapStateToProps = (state, { examId, questionId }) => {
  return {
    examStatus: getExamLoadingStatus(state, examId),
    question: getQuestion(state, questionId),
    solution: getSolution(state, questionId),
    examId,
    questionId,
  };
};

const mapDispatchToProps = (dispatch) => ({
  loadExam: (examId) => dispatch(loadExam.signal(examId)),
  loadExamSolution: (examId) => dispatch(loadExamSolution.signal(examId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeacherQuestionView);
